"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDynamicValueBindingCallback = resolveDynamicValueBindingCallback;
function resolveDynamicValueBindingCallback(params, binding) {
    return binding.value(params.context);
}
//# sourceMappingURL=resolveDynamicValueBindingCallback.js.map